/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Datatable from "../../bmr/components/features/Datatable";
import Filter from "../../bmr/pages/QualityControl/Filter";
import { Button } from "@mui/material";
import Loadable from "../../components/Loadable";
const CustomModel = Loadable(React.lazy(() => import('../../components/custom-model/CustomModel')));
import {
    getProgramCodeList,
    createProgramCode,
    updateProgramCode,
    deleteProgramCode,
    selectProgramCodeList,
} from "../../bmr/slices/program";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
    DeleteIconButton,
    EditIconButton
} from "../../assets/common-svg/CommonSvg";
import { addProgramListInitialValues } from "../../utils/formik/initialValues"
import { addProgramValidationSchema } from "../../utils/formik/validationSchema"
import DeleteConfirmContent from "../../components/modal-contents/DeleteConfirmModalContent"
import PhaseApi from "../../services/phase.js";
import { notify } from "../../bmr/utils/methods/notification";

const ProgramCodes = () => {
    const dispatch = useDispatch();
    const programList = useSelector(selectProgramCodeList);

    const [openAddProgressModal, setOpenAddProgressModal] = React.useState(false);
    const [openEditProgressModal, setOpenEditProgressModal] = React.useState(false);
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = React.useState(false);
    const [initialValues, setInitialValues] = useState(addProgramListInitialValues)
    const [rowId, setRowId] = useState(null)
    const [deleteRowData, setDeleteRowData] = useState(null)
    const [submitLoading, setSubmitLoading] = useState(false);
    const [filterConfig, setFilterConfig] = useState({
        phase_type: {
            label: "Type",
            enum: {},
        },
    });

    const [modelData, setModelData] = useState({
        title: "Add New Program Code",
        editTitle: "Edit Program Code",
        children: [
            { type: "dropdown", name: "phase_type_id", label: "Phase Type", placeholder: "Select Phase Type", data: [], IsRequired: true },
            { type: "input", name: "code", label: "Code", placeholder: "Enter Code", IsRequired: true },
        ]
    })

    // Function to get Phase Type Dropdown
    const getPhaseTypeDropDown = async () => {
        try {
            const result = await PhaseApi.getPhaseTypeDropDown();
            // Assuming result.data = [{ id: 1, name: "Trial" }, { id: 2, name: "PMS" }, ...]
            const enumData = result?.data?.reduce((acc, item) => {
                acc[item.id] = item.name;
                return acc;
            }, {});

            // ✅ Update filterConfig dynamically
            setFilterConfig((prev) => ({
                ...prev,
                phase_type: {
                    ...prev.phase_type,
                    enum: enumData,
                },
            }));
            setModelData((prevState) => ({
                ...prevState,
                children: prevState.children.map((child) =>
                    child.name === "phase_type_id" ? { ...child, data: result?.data } : child
                ),
            }));
        } catch (error) {
            notify.error(error)
        }
    };

    const tableData = {
        items: programList?.items || programList?.data || [],
        total_count:
            programList?.pageDetails?.no_of_records ||
            programList?.no_of_records ||
            0,
        page: programList?.pageDetails?.page || 1,
        per_page: programList?.pageDetails?.per_page || 10,
    };

    const handleServerSideChange = async (params) => {
        try {
            await dispatch(getProgramCodeList(params));
        } catch (error) {
            console.error("Error fetching program code data:", error);
        }
    };

    // Initial data fetch
    useEffect(() => {
        getPhaseTypeDropDown()
        handleServerSideChange({ page: 1, per_page: 10 });
    }, []);



    const handleOpenAddProgressModal = () => {
        setInitialValues(addProgramListInitialValues)
        setRowId("")
        setOpenAddProgressModal(true);
    }

    const handleopenEditProgressModal = (row) => {
        const editData = tableData?.items?.find(codeData => codeData?.id === row?.id);
        if (editData?.is_assign) {
            notify.error(`Program code already assign, can't be delete this`)
            return
        }
        setRowId(row?.id)
        setInitialValues({
            phase_type_id: editData?.phase_type_id,
            code: editData?.code,
        })
        setOpenEditProgressModal(true);
    }

    const handleAddModelValues = async (values) => {
        setSubmitLoading(true);
        const result = await dispatch(createProgramCode(values))
        if (createProgramCode.fulfilled.match(result)) {
            handleServerSideChange({ page: 1, per_page: 10 });
            setOpenAddProgressModal(false);
        }
            setSubmitLoading(false);

    }


    const handleEditModelValues = async(values) => {
        setSubmitLoading(true);
        const result = await dispatch(updateProgramCode({id:rowId,formData:values}))
        if (updateProgramCode.fulfilled.match(result)) {
            handleServerSideChange({ page: 1, per_page: 10 });
                setOpenEditProgressModal(false);
    }
        setSubmitLoading(false);
  }

    const handleOpenDeleteConfirmModal = (row) => {
        const editData = tableData?.items.find(codeData => codeData?.id === row?.id);
        if (editData?.is_assign) {
            notify.error(`Program code already assign, can't be delete this`)
            return
        }
        setOpenDeleteConfirmModal(true);
        setDeleteRowData(row)
    }

    const handleDeleteRow = async() => {
        setSubmitLoading(true)
        setOpenDeleteConfirmModal(false);
        const result = await dispatch(deleteProgramCode({id:deleteRowData?.id}))
        if (deleteProgramCode.fulfilled.match(result)) {
            handleServerSideChange({ page: 1, per_page: 10 });
            }
           setSubmitLoading(false);
    }

    const columns = [
        {
            id: "id",
            name: "ID",
            selector: (row) => (row.id ? row.id : "N/A"),
            sortable: true,
        },
        {
            id: "name",
            name: "Phase Type Name",
            selector: (row) => (row?.phase_type_details?.name ? row?.phase_type_details?.name : "N/A"),
            sortable: true,
        },
        {
            id: "code",
            name: "Code",
            selector: (row) =>
                row.code ? row?.code : "N/A",
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => (<>
                <Tooltip title="Edit">
                    <span>
                        <IconButton

                        >
                            <EditIconButton

                                bgColor={"#C3C3C3"}
                                handleOnClick={() =>
                                    handleopenEditProgressModal(row)
                                }
                            />
                        </IconButton>
                    </span>
                </Tooltip>

                <Tooltip title="Delete">
                    <span>
                        <IconButton
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                                handleOnClick={() =>
                                    handleOpenDeleteConfirmModal(row)
                                }
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </>),
        },
    ];

    return (
        <Grid
            container
            className="mt-4 ml-0 mr-3 mainDiv"
            rowSpacing={4.5}
            columnSpacing={2.75}
        >
            <Grid item xs={12} sx={{ mt: -2.25 }}>
                <div>
                    <Datatable
                        columns={columns}
                        data={tableData}
                        title="Program Codes"
                        FilterComponent={Filter}
                        onServerSideChange={handleServerSideChange}
                        remote={true}
                        BtnComponent={<Button className="ml-2" onClick={() => (handleOpenAddProgressModal(), setRowId(null))}>Add New</Button>}
                        filterConfig={filterConfig}
                        searchPlaceholder="Search By Name / Phase Type"
                    />
                </div>
            </Grid>
            <DeleteConfirmContent open={openDeleteConfirmModal} setOpen={setOpenDeleteConfirmModal} handleDelete={handleDeleteRow} isLoading={submitLoading} />
            <CustomModel
                rowId={rowId}
                modalInitialValues={initialValues}
                initialValuesValidationSchema={addProgramValidationSchema}
                open={openEditProgressModal ? openEditProgressModal : openAddProgressModal}
                setOpen={openEditProgressModal ? setOpenEditProgressModal : setOpenAddProgressModal}
                setModelData={setModelData}
                modelData={modelData}
                handleModelValues={openEditProgressModal ? handleEditModelValues : handleAddModelValues}
                isLoadingBtn={submitLoading}
            />
        </Grid>
    );
};

export default ProgramCodes;
